import { Form, FormProps, Select, SelectProps } from "antd";
import { useEffect, useState } from "react";
import api from "../../../common/api";
import { NamePath } from "antd/es/form/interface";
import { ICashbox } from "common/types/cashbox";

interface ICashboxSelectSelect<T = any> {
  label?: string;
  placeholder?: string;
  form?: FormProps["form"];
  name?: NamePath<T>;
  onSelect?: (value: any) => void;
  multiple?: boolean;
  preprocessOptions?: (options: ICashbox[]) => ICashbox[];
  [key: string]: unknown;
}

const CashboxSelect = <T,>({
  label = "Kassa",
  placeholder = "Kassani tanlang",
  form,
  name,
  onSelect,
  multiple = false,
  preprocessOptions = (options) => options,
  ...props
}: ICashboxSelectSelect<T>) => {
  const [options, setOptions] = useState<SelectProps["options"]>([]);
  const [loading, setLoading] = useState(false);
  const handleChange = (value: string[]) => {
    if (form && name) form?.setFieldValue(name, value || undefined);
    if (onSelect) onSelect(value || undefined);
  };

  const transactionGetAll = async () => {
    try {
      setLoading(true);
      const response = await api.cashbox.getAll();
      setOptions(
        preprocessOptions(response.data).map((cashbox) => ({
          label: cashbox.name,
          value: cashbox._id,
        }))
      );
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    transactionGetAll();
  }, []);

  return (
    <Form.Item name={name} label={label} style={{ margin: 0 }} {...props}>
      <Select
        mode={multiple ? "multiple" : undefined}
        allowClear
        style={{ minWidth: "200px" }}
        placeholder={placeholder}
        onChange={handleChange}
        options={options}
        loading={loading}
      />
    </Form.Item>
  );
};

export default CashboxSelect;
